module.exports = __webpack_public_path__ + "static/media/1396940_10205799532528035_718387596375389081_o.80dab5a8.jpg";